module.exports = __webpack_public_path__ + "img/18.6e912e67.jpg";